import React from "react";
import { useHistory } from "react-router-dom";
import shallow from "zustand/shallow";
import { useCreatePurchaseStore } from "../../stores/createPurchaseStore";
import { SecondaryButton } from "../Common/SecondaryButton";
import { CheckoutSubmitButton, CheckoutSubmitButtonProps } from "./CheckoutSubmitButton";
import { CreatePurchaseFooter } from "./CreatePurchaseFooter";
import { getPurchaseItemsHavingId } from "./helpers/PurchaseCreateHelpers";
import JoinWaitlistButton from "./JoinWaitlistButton";
import { useSeller } from "@/hooks/useAccount";

interface CheckoutPurchaseScreenFooterProps extends CheckoutSubmitButtonProps {
    onCancel: () => void;
    secondaryText?: string;
}

export const CheckoutPurchaseScreenFooter = ({
    onCancel,
    secondaryText = "Back",
    ...rest
}: CheckoutPurchaseScreenFooterProps) => {
    const seller = useSeller();

    const history = useHistory();
    const [purchaseId, product, packageId] = useCreatePurchaseStore((state) => {
        return [state.purchaseId, state.getActiveProduct(), state.getPurchasePackageId()];
    }, shallow);

    const setPurchase = useCreatePurchaseStore((state) => state.actions.setPurchase);
    const isPartnerExperience = product?.seller.id !== seller.id;
    const isWaitListMode = useCreatePurchaseStore((state) => state.isWaitListMode());

    const handleAddNewProductClick = async () => {
        setPurchase((draft) => getPurchaseItemsHavingId(draft));

        history.push("/cart/init", { isAddingItem: true });
    };

    return (
        <CreatePurchaseFooter secondaryText={secondaryText} onCancel={onCancel}>
            {isWaitListMode ? <JoinWaitlistButton /> : purchaseId && <CheckoutSubmitButton {...rest} />}

            {packageId || !purchaseId ? null : (
                <SecondaryButton disabled={isPartnerExperience || isWaitListMode} onClick={handleAddNewProductClick}>
                    Add Another Product
                </SecondaryButton>
            )}
        </CreatePurchaseFooter>
    );
};
